// Registration Charity Number (Issue Fixer 10, Monday 13314529366). Staff
// design: CMP Dashboard (20) Update Member Form :521-526 (Member Insights,
// before "Year member was established") and Mockup Thunderbay Chamber Set Up
// :4757-4761 (Create Member, under the membership type, with the helper
// text). The staff design has no required mark: the field is optional.
// CAP flags the membership types (collectsCharityRegistrationNumber, from the
// type name), so the dashboard does not repeat the name rule.

export const MEMBER_CHARITY_REGISTRATION_NUMBER_FIELD_ID =
  "member-charity-registration-number";
// Design (21) CMP Dashboard.dc.html:6622-6624, Update Member Form :540-541
// renamed the staff label to "Registered" (Monday 13314913185). The website
// keeps its own design text (Chamber Website (13)).
export const MEMBER_CHARITY_REGISTRATION_NUMBER_LABEL =
  "Registered Charity Number";
export const MEMBER_CHARITY_REGISTRATION_NUMBER_PLACEHOLDER =
  "Enter Registered Charity Number";
export const MEMBER_CHARITY_REGISTRATION_NUMBER_HELPER =
  "Enter the member's CRA registered charity number.";

type CharityFlaggedMembershipModel = {
  collectsCharityRegistrationNumber?: boolean | null;
};

// Shown for a flagged type. Update Member also shows a saved number, so
// staff can see and clear it after the type changes.
export const shouldShowMemberCharityRegistrationNumber = ({
  membershipModels,
  savedValue,
}: {
  membershipModels: Array<CharityFlaggedMembershipModel | null | undefined>;
  savedValue?: string | null;
}): boolean =>
  membershipModels.some(
    (model) => model?.collectsCharityRegistrationNumber === true,
  ) || !!(savedValue || "").trim();

// Sent only while the field is shown. CAP keeps the saved number when the
// save does not send the field; "" clears it.
export const getMemberCharityRegistrationNumberInput = ({
  shown,
  value,
}: {
  shown: boolean;
  value: string | null | undefined;
}): { charityRegistrationNumber?: string } =>
  shown ? { charityRegistrationNumber: (value || "").trim() } : {};
